import { mediaQueryMap } from '@leagueplatform/genesis-core';

export const getCurrentBreakpoint = (
  breakpoints: Record<string, string> = mediaQueryMap,
): string | undefined =>
  Object.entries(breakpoints).find(
    ([, query]) => window.matchMedia(query).matches,
  )?.[0] ?? undefined;
